import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import logoHais from "../images/logo.png";
import { markdownToReactPdf } from "./ASTConverter";

const formatDateTime = (date) =>
  `${date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })} ${date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 24,
    paddingBottom: 32,
    fontSize: 12,
    color: "#333333",
  },
  highlightBox: {
    backgroundColor: "#f0f0f0",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 4,
    marginBottom: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  highlightText: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#333333",
  },
  logo: {
    height: 25,
    width: 25,
    objectFit: "contain",
  },
  content: {
    fontSize: 12,
    lineHeight: 1.6,
    color: "#333333",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    right: 24,
    fontSize: 10,
    color: "#333333",
  },
});

const PatientSummaryPdf = ({ patient, patientSummary }) => {
  const generationDateTime = formatDateTime(new Date());

  const HeaderBox = () => (
    <View style={styles.highlightBox}>
      <Text style={styles.highlightText}>{patient}</Text>
      <Image style={styles.logo} src={logoHais} />
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Cabeçalho */}
        <HeaderBox />

        {/* Conteúdo */}
        <View style={styles.content}>
          {markdownToReactPdf(patientSummary)}
        </View>

        {/* Rodapé fixo em cada página */}
        <Text style={styles.footer} fixed>
          Gerado em: {generationDateTime}
        </Text>
      </Page>
    </Document>
  );
};

export default PatientSummaryPdf;
